<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="8">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('table_label_search') ||
                  'SKU编号/NC编号/产品名称/合同号 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <el-select
              size="mini"
              style="width: 120px;"
              class="ml-2 el-selct-date-range "
              @change="changeDateRange"
              v-model="form.dateRange"
              placeholder="请选择"
            >
              <el-option
                v-for="item in dateRangeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-date-picker
              v-model="form.lastShipmentDate"
              type="date"
              size="mini"
              class="ml-2 el-selct-date-range"
              style="width: 150px;"
              value-format="yyyy-MM-dd"
              :disabled="disabledChooseDate"
              :picker-options="pickerOptions"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              @change="query"
              align="right"
            >
            </el-date-picker>
            <slot :form="form" />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form
        ref="form"
        :model="form"
        size="small"
        label-width="100px"
        label-position="left"
      >
        <el-row :gutter="10" class="mt-2">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_amzSkuNo') || 'SKU'">
              <el-input
                v-model="form.amzSkuNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_amzSpuNo') || 'SPU'">
              <el-input
                v-model="form.amzSpuNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_goodsName') || '产品名称'">
              <el-input
                v-model="form.goodsName"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_goodsColor') || '产品颜色'">
              <el-input
                v-model="form.goodsColor"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_goodsSize') || '产品尺寸'">
              <el-input
                v-model="form.goodsSize"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_poNo') || '合同号'">
              <el-input
                v-model="form.poNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_scm') || '工厂'">
              <dict-select
                v-model="form.scmCode"
                url="/master/common/dict/scmCooperated"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                style="width: 100%"
                filterable
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('form_label_purchaseDate') || '采购下单时间'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.purchaseDateStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.purchaseDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="0">
              <el-form-item
                :label="$l('form_label_deliveryDate') || '工厂订单交期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDateStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDateEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'
const initForm = {
  keyword: '',
  dateRange: 'B',
  lastShipmentDate: dayjs()
    .subtract(1, 'month')
    .toDate(),
}
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      disabledChooseDate: true,
      dateRangeOptions: [
        {
          label: this.$l('btn_last_week') || '最近一周',
          value: 'A',
          fun: () => {
            let end = dayjs()
            const start = end.subtract(1, 'week').toDate()
            return start
          },
        },
        {
          label: this.$l('btn_last_one_months') || '最近一个月',
          value: 'B',
          fun: () => {
            let end = dayjs()
            const start = end.subtract(1, 'month').toDate()
            return start
          },
        },
        {
          label: this.$l('btn_last_two_months') || '最近两个月',
          value: 'C',
          fun: () => {
            let end = dayjs()
            const start = end.subtract(2, 'month').toDate()
            return start
          },
        },
        {
          label: this.$l('btn_last_three_months') || '最近三个月',
          value: 'D',
          fun: () => {
            let end = dayjs()
            const start = end.subtract(3, 'month').toDate()
            return start
          },
        },
        {
          label: this.$l('btn_last_six_months') || '最近半年',
          value: 'G',
          fun: () => {
            let end = dayjs()
            const start = end.subtract(6, 'month').toDate()
            return start
          },
        },
        {
          label: this.$l('btn_last_year') || '最近一年',
          value: 'H',
          fun: () => {
            let end = dayjs()
            const start = end.subtract(1, 'year').toDate()
            return start
          },
        },
        {
          label: this.$l('btn_custom_time') || '自定义时间',
          value: 'Z',
          fun: () => {
            return ''
          },
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: this.$l('btn_last_week') || '最近一周',
            onClick(picker) {
              let end = dayjs()
              const start = end.subtract(1, 'week').toDate()
              picker.$emit('pick', start)
            },
          },
          {
            text: this.$l('btn_last_one_months') || '最近一个月',
            onClick(picker) {
              let end = dayjs()
              const start = end.subtract(1, 'month').toDate()
              picker.$emit('pick', start)
            },
          },
          {
            text: this.$l('btn_last_two_months') || '最近两个月',
            onClick(picker) {
              let end = dayjs()
              const start = end.subtract(2, 'month').toDate()
              picker.$emit('pick', start)
            },
          },
          {
            text: this.$l('btn_last_three_months') || '最近三个月',
            onClick(picker) {
              let end = dayjs()
              const start = end.subtract(3, 'month').toDate()
              picker.$emit('pick', start)
            },
          },
          {
            text: this.$l('btn_last_six_months') || '最近半年',
            onClick(picker) {
              let end = dayjs()
              const start = end.subtract(6, 'month').toDate()
              picker.$emit('pick', start)
            },
          },
          {
            text: this.$l('btn_last_year') || '最近一年',
            onClick(picker) {
              let end = dayjs()
              const start = end.subtract(1, 'year').toDate()
              picker.$emit('pick', start)
            },
          },
        ],
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.disabledChooseDate = true
      this.form = { ...initForm }
    },
    changeDateRange(val) {
      if (val == 'Z') {
        this.form.lastShipmentDate = ''
        this.disabledChooseDate = false
        return
      }
      let dateRange = this.dateRangeOptions.filter((e) => e.value == val)
      if (dateRange && dateRange.length > 0) {
        this.form.lastShipmentDate = dateRange[0].fun()
        this.disabledChooseDate = true
      }
      this.query()
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
::v-deep {
  .el-selct-date-range {
    .el-input {
      input {
        border-right: 1px solid #dcdfe6;
      }
      input:focus {
        border-color: #409eff;
      }
    }
    input {
      border-right: 1px solid #dcdfe6;
    }
    input:focus {
      border-color: #409eff;
    }
  }
}
</style>
